import { render } from "./index_expired.vue?vue&type=template&id=ff3ea09e"
import script from "./index_expired.vue?vue&type=script&lang=js"
export * from "./index_expired.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__